import { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { OldAwesomeFilter } from 'components/custom-icon/OldAwesomeFilter';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import FilterPopover from 'components/filtering/filter-popover/FilterPopover';
import { SortObject, SortModeEnum } from 'components/filtering/types/SortObject';
import { FilterObject, FilterValue } from 'components/filtering/types/FilterObject';
import useBaseGridHeader from 'components/filtering/base-grid-header/useBaseGridHeader';



export interface BaseGridHeaderProps<T> {
	label: string,
	propertyName: keyof T,
	sortObject?: SortObject<T> | null,
	filterObject?: FilterObject<T>,
	onSearchValues?: (property: keyof T, checkedValues: unknown[]) => void,
	onAddFilterValues?: (property: keyof T, showedFilterValues: FilterValue[]) => void,
	onClearFilter?: (property: keyof T) => void,
	onSorting?: (property: keyof T, mode: SortModeEnum) => void,
	onClearSorting?: (property: keyof T) => void,
}


const BaseGridHeader = <T extends unknown>(props: BaseGridHeaderProps<T>) => {
	const { label, propertyName, sortObject, filterObject, onSearchValues, onAddFilterValues } = props;


	const [ filterValues, activeFilter, handleSearchValues, handleAddFilterValues, handleSorting, handleClear ] = useBaseGridHeader(props);

	
	if (!label || label.length === 0) return (
		<div className='app-grid-header centered-header'>
		</div>
	);

	if (filterObject === undefined && onAddFilterValues === undefined && onSearchValues === undefined) return (
		<div className='app-grid-header centered-header'>
			<p>{label}</p>
		</div>
	);

	return (
		<div className='app-grid-header centered-header'>
			<p>{label}</p>
			
			<OverlayTrigger
				trigger="click"
				placement="auto-start"
				rootClose={true}
				overlay={(props) =>
					<FilterPopover
						filterValues={filterValues}
						onSearchValues={handleSearchValues}
						onAddFilterValues={handleAddFilterValues}
						onSorting={handleSorting}
						onClear={handleClear}
						activeSortMode={sortObject && sortObject.property === propertyName ? sortObject.mode : null}
						others={props}
					/>
				}
			>		
				
				<div className='grid-header-filter'>	
					
					{sortObject && sortObject.property === propertyName && sortObject.mode === SortModeEnum.asc &&
						<FontAwesomeIcon className='app-grid-header-icon sorting-icon' icon={faArrowDown} />}
					{sortObject && sortObject.property === propertyName && sortObject.mode === SortModeEnum.desc &&
						<FontAwesomeIcon className='app-grid-header-icon sorting-icon' icon={faArrowUp} />}
				
					<OldAwesomeFilter className={`app-grid-header-icon filter-icon${activeFilter ? ' active' : ''}`} />
				</div>
			</OverlayTrigger>
		</div>
	);
};

export default memo(BaseGridHeader);